"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RGSPay = void 0;
const react_1 = __importDefault(require("react"));
const rgs_pay_1 = __importDefault(require("../icons-path/rgs-pay"));
const icons_svg_1 = require("../icons-svg");
const icons_constants_1 = require("../icons.constants");
require("../icons.types");
const RGSPay = (props) => {
    return react_1.default.createElement(icons_svg_1.IconsSvg, Object.assign({ viewBox: icons_constants_1.rgsViewBox }, props, { path: rgs_pay_1.default }));
};
exports.RGSPay = RGSPay;
